import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';

import { RpeNsm1Component } from './rpe-nsm1/rpe-nsm1.component';
import { RpeNsm2Component } from './rpe-nsm2/rpe-nsm2.component';
import { RpeNsp2p1Component } from './rpe-nsp2p1/rpe-nsp2p1.component';
import { RpeNst2t1Component } from './rpe-nst2t1/rpe-nst2t1.component';
import { RpeDva1Component } from './rpe-dva1/rpe-dva1.component';


// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { RpeNsm1Component } from './rpe-nsm1/rpe-nsm1.component';
// import { RpeNsm2Component } from './rpe-nsm2/rpe-nsm2.component';
// import { RpeNsp2p1Component } from './rpe-nsp2p1/rpe-nsp2p1.component';
// import { RpeNst2t1Component } from './rpe-nst2t1/rpe-nst2t1.component';
// import { RpeDva1Component } from './rpe-dva1/rpe-dva1.component';


// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { RpeNstabComponent } from './rpe-nstab/rpe-nstab.component';
// import { MatTabsModule } from '@angular/material/tabs';
// import { RpeNsm1Component } from './rpe-nsm1/rpe-nsm1.component';
// import { ReactiveFormsModule } from '@angular/forms'; // Import this

// import { RpeNst2t1Component } from './rpe-nst2t1/rpe-nst2t1.component';
// import { RpeDva1Component } from './rpe-dva1/rpe-dva1.component';


@NgModule({
  declarations: [

    // RpeNsm1Component,
    // RpeNsm2Component,
    // RpeNsp2p1Component,
    // RpeNst2t1Component,
    // RpeDva1Component,
    // RpeNsm1Component,
    // RpeNsm2Component,
    // RpeNsp2p1Component,
    // RpeNst2t1Component,
    // RpeDva1Component,
    // RpeNstabComponent, // Declare non-standalone components here

    // MatTabsModule
    // RpeNsm1Component
    // RpeNst2t1Component,
    // RpeDva1Component
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTabsModule,
    // ReactiveFormsModule,
    // MatTabsModule,
    // RpeNstabComponent,

  ],
  exports: [

    // RpeNsm1Component,
    // RpeNsm2Component,
    // RpeNsp2p1Component,
    // RpeNst2t1Component,
    // RpeDva1Component,

    // RpeNsm1Component,
    // RpeNsm2Component,
    // RpeNsp2p1Component,
    // RpeNst2t1Component,
    // RpeDva1Component, 
    // // RpeNstabComponent
    // RpeNsm1Component
  ]
})
export class RpeNspMdlModule { }
